import { Box } from '@mui/material';

import VerifiedIcon from '@/shared/ui/icons/Verified.svg';

interface IProps {
  size?: number;
}

/**
 * Галка подтверждённого профиля для вставки в текстовую строку сразу после
 * фамилии. Живёт в контейнере нулевой ширины: места в строке не занимает,
 * поэтому браузер не переносит её отдельно от фамилии и не обрезает по краю.
 * @param props - пропсы компонента
 * @param props.size - размер иконки в пикселях
 */
export const VerifiedBadge = ({ size = 24 }: IProps) => (
  <Box
    component='span'
    sx={{ display: 'inline-block', width: 0, whiteSpace: 'nowrap' }}
  >
    <VerifiedIcon
      role='img'
      aria-label='Профиль подтверждён'
      style={{
        // Перебиваем глобальный сброс `img, svg { display: block;
        // max-width: 100% }` из admin-v2.css: display — иначе иконка рвёт
        // строку, maxWidth — иначе схлопывается в нулевом контейнере
        display: 'inline-block',
        maxWidth: 'none',
        width: size,
        height: size,
        marginLeft: 4,
        verticalAlign: 'text-bottom'
      }}
    />
  </Box>
);
